import { MenuItem } from '@material-ui/core';
import { TextField } from '@avangard/ui/core';
import { CommonHelper } from '@helpers';
import { useLapsWithCertificates } from '@modules/lap/hooks';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

type DownloadCertificateProps = {
    schoolId: string;
};

const Root = styled.div`
    min-width: 185px;
    margin-inline-end: 16px;
`;

const DownloadCertificate = (props: DownloadCertificateProps): React.ReactElement | null => {
    const { t } = useTranslation();

    const { lapsWithCertificates } = useLapsWithCertificates({
        fetchPolicy: 'network-only',
        variables: { schoolId: props.schoolId },
    });

    const handleChooseCertificateForDownload = async (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        const lapWithCertificate = lapsWithCertificates.find(
            entity => entity.lap.id === event.target.value,
        );

        if (!lapWithCertificate) {
            return;
        }

        CommonHelper.downloadUrl(lapWithCertificate.certificatesUrl);
    };

    return (
        <Root>
            <TextField select fullWidth value='' onChange={handleChooseCertificateForDownload}>
                <MenuItem value=''>{t('common:actions.download_certificates')}</MenuItem>

                {lapsWithCertificates.map(lapWithCertificate => (
                    <MenuItem key={lapWithCertificate.lap.id} value={lapWithCertificate.lap.id}>
                        {lapWithCertificate.lap.getFormattedName({ withPlatform: false })}
                    </MenuItem>
                ))}
            </TextField>
        </Root>
    );
};

export { DownloadCertificate };
